




































import { Component, Prop, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { BDropdown } from 'bootstrap-vue';
import { ITask, TaskPriority, TaskPriorityLabels } from 'admiral-core';
import { CheckIcon } from 'vue-feather-icons';
import TaskPriorityIcon from './TaskPriorityIcon.vue';

@Component({
  name: 'TaskPriorityMenu',
  components: {
    TaskPriorityIcon,
    CheckIcon,
  },
})
export default class TaskPriorityMenu extends Vue {
  @Prop({ type: Object, required: true }) task!: ITask;
  @Prop({ type: String, default: 'md' }) iconSize!: 'sm' | 'md' | 'lg';

  @Ref('dropdown') dropdownRef!: BDropdown;

  get taskPriority(): TaskPriority {
    return this.task.priority ?? TaskPriority.NO_PRIORITY;
  }

  get priorityOptions(): { priority: TaskPriority; label: string }[] {
    return Object.values(TaskPriority).map((priority) => ({
      priority,
      label: TaskPriorityLabels[priority],
    }));
  }

  hideMenu() {
    this.dropdownRef?.hide();
  }

  onOverlayOpened() {
    const parent = this.$el.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.add('task-priority-dropdown-open');
  }

  onOverlayClosed() {
    const parent = this.$el.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.remove('task-priority-dropdown-open');
  }

  onSelectPriority(newPriority: TaskPriority) {
    this.hideMenu();
    if (this.taskPriority === newPriority) return;
    this.$emit('priority-change', newPriority);
  }
}
